var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('vs-card',{staticClass:"shadow-none text-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('global.Welcome')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }